'use client';

import type { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { theme } from '../../theme';

const HrBase = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(${theme.borderPrimary});
`;

export const Hr = (props: HTMLAttributes<HTMLDivElement>) => {
  const { ...rest } = props;
  return <HrBase {...rest} />;
};
